/** Manufacturer F200 MIB 2.0.6, published for firmware 3021 and newer.
 * Names match the collected SNMP fields; physical wiring is not inferred.
 */
export const F200_MIB_URL = 'https://rle.parameter-tech.com/wp-content/uploads/2020/05/F200MIB_206.mib';
export const F200_DATASHEET_URL =
  'https://rletech.com/wp-content/uploads/2022/06/Falcon-F200-Datasheet-06.22.pdf';
export const F200_DIMENSIONS_M = { width: 0.143, height: 0.025, depth: 0.067 } as const;

export function f200State(kind: 'input' | 'relay' | 'leak', value: number): string {
  if (value !== 0 && value !== 1) return `Unknown code (${value})`;
  const labels = {
    input: ['Circuit open', 'Circuit closed'],
    relay: ['De-energized', 'Energized'],
    leak: ['No leak alarm reported', 'Leak alarm reported'],
  };
  return `${labels[kind][value]} (${value})`;
}

/** A comparison with reported configuration, not a site-health diagnosis. */
export function configuredExcursion(
  value: number,
  low: number,
  high: number,
): 'below' | 'above' | 'within' | 'invalid' {
  if (![value, low, high].every(Number.isFinite) || low > high) return 'invalid';
  return value < low ? 'below' : value > high ? 'above' : 'within';
}

export const F200_PORTS = [
  {
    id: 'sensor1',
    label: 'Sensor input 1',
    field: 'sensor1Temperature / sensor1Humidity',
    note: 'Measured temperature and humidity at input 1. Probe mounting and part number are unverified.',
    readings: ['temperature', 'humidity', 'temp_limits', 'humidity_limits'],
  },
  {
    id: 'digital8',
    label: 'Digital input 8',
    field: 'digInput8State',
    note: 'Electrical circuit state. An open circuit does not establish that a physical door is open; the connected equipment and alarm polarity are unknown.',
    readings: ['door'],
  },
  {
    id: 'leak',
    label: 'Leak zone',
    field: 'leak1Alarm',
    note: 'Device-reported leak alarm. A zero does not prove that a cable is connected, enabled or covering the whole site.',
    readings: ['leak'],
  },
  {
    id: 'relay',
    label: 'Relay output',
    field: 'relay1State',
    note: 'Coil energization reported by the monitor. Attached load, NO/NC wiring and operating purpose are unknown.',
    readings: ['relay'],
  },
] as const;
